import { render } from "./ChainCard.vue?vue&type=template&id=2bc5e053&scoped=true"
import script from "./ChainCard.vue?vue&type=script&lang=js"
export * from "./ChainCard.vue?vue&type=script&lang=js"

import "./ChainCard.vue?vue&type=style&index=0&id=2bc5e053&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc5e053"]])

export default __exports__